<template>
	<el-row class="points-show">
		<!-- 顶部栏 -->
		<el-col :span="24">
			<el-col :span="10">销售计划</el-col>
			<el-col :span="4" :offset="10">
				<el-button type="primary" size="mini" style="margin-left: 30px" @click="addPlan(1,0)" plain>
					创建销售计划<i class="el-icon-plus"></i>
				</el-button>
			</el-col>
		</el-col>
		<el-divider></el-divider>
		<!-- table -->
		<el-col :span="24">
			<el-table :data="tableData" :height="tableHeight">
				<el-table-column type="index" width="70" label="序号"></el-table-column>
				<el-table-column prop="planTitle" label="计划名称" />
				<el-table-column label="计划日期">
					<template slot-scope="scope">
						<span>
							{{scope.row.startTime}} ~ {{scope.row.endTime}}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="deleteStatus" label="显示状态">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.deleteStatus == 0" type="success" size="mini">显示
						</el-tag>
						<el-tag v-if="scope.row.deleteStatus == 1" type="warning" size="mini">隐藏
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="编辑时间">
					<template slot-scope="scope">
						<span>{{ scope.row.updateTime | formatDate }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="230px">
					<template slot-scope="scope">
						<el-button plain size="mini" type="info" @click="addPlan(2, scope.$index)">编辑
						</el-button>
						<el-button plain type="danger" size="mini" @click="delPlan(scope.row.planId)">删除
						</el-button>
						<!--                        <el-button-->
						<!--                                plain-->
						<!--                                type="primary"-->
						<!--                                size="mini"-->
						<!--                                @click="infoPlan(scope.$index)"-->
						<!--                        >详情-->
						<!--                        </el-button-->
						<!--                        >-->
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange" @size-change="handleSizeChange"
				:page-sizes="pageSizes">
			</el-pagination>
		</el-col>
		<!-- 选择商品 -->
		<planListPopUps :planListShow="planListShow" :addForm="addForm" v-on:close="planClose($event)"></planListPopUps>
	</el-row>
</template>

<script>
	import {
		getGroupList
	} from '../../../util/index.js'
	import planListPopUps from '../../../components/popUps/PlanListPopUps.vue'

	var vm;
	export default {
		components: {
			planListPopUps
		},
		data() {
			return {
				planListShow: false,
				isShow: false,
				addForm: {
					planId: '',
					planTitle: '',
					startTime: '',
					endTime: '',
					titleType: 0,
					infoList: [], // 选择的商品
					infoTypes: '',
				},
				name: '',
				startTime: '',
				endTime: '',
				mainCategory: '',
				status: '',
				currentOptionIndex: -1, //要给哪个弹框添加商品
				total2: 0,
				pageNum2: 1,
				pageSize2: 10,
				tableDataProduct: [],
				keyword: "",
				table: false,
				tableHeight: window.innerHeight - 300,
				dialogVisible: false,
				pageSize: 10,
				pageSizes: [10, 20, 30, 40, 50],
				pageNum: 1,
				tableData: [],
				total: 0,
				reviewStatus: [{
						title: "显示",
						type: 0,
					},
					{
						title: "隐藏",
						type: 1,
					},
				],
				planLists: [],
				selectContextShow: false,
				selectContextText: ''
			};
		},
		mounted() {
			vm = this;
			this.getTable();
			this.searchProduct(); //查询商品
			this.selectPlan();
		},
		filters: {
			// 使用计算属性
			formatDate(val) {
				return val ? vm.$moment(val).format("YYYY-MM-DD HH:MM:SS") : "";
			},
		},
		methods: {
			// 点击添加商品
			addField() {
				this.selectContextShow = true;
			},
			// 查询主题
			selectPlan() {
				this.$http
					.get(
						`/api/source/clrWeekPlan/selectDicType?parentId=1`
					)
					.then((res) => {
						if (res.data.status == 0) {
							let list = res.data.data;
							this.planLists = list;
						} else {
							this.$message({
								type: "error",
								message: "系统繁忙，请稍后再试~~",
							});
						}
					});
			},
			planClose(res) {
				this.planListShow = res;
			},
			// 查看详情
			infoPlan(index) {

				const newAddForm = this.tableData[index];
				this.addForm = newAddForm;

				this.selectList(this.addForm.planId, this.addForm.titleType, this.addForm.infoTypes)
				this.planListShow = true;
			},
			selectList(num, type, infoTypes) {
				this.$http.post('/api/source/clrWeekPlan/selectPlanInfo', {
					planId: num,
					titleType: type,
					infoTypes: infoTypes,

				}).then(res => {
					// console.log(JSON.stringify(res)+"============res=send=========")
					this.addForm = res.data.data
					console.log(JSON.stringify(this.addForm) + "=-====res===========")
					// this.addForm.infoList = res.data.data;
				});
			},
			//获取数据列表
			getTable() {
				let data = {
					deleteStatus: 0
				}
				this.$http
					.post(
						`/api/source/clrWeekPlan/selectPlanList?pageNum=${this.pageNum}&pageSize=${this.pageSize}`,
						data
					)
					.then((res) => {
						if (res.data.status == 0) {
							let list = res.data.data.list;
							this.tableData = list;
							this.total = res.data.data.total;
						} else {
							this.$message({
								type: "error",
								message: "系统繁忙，请稍后再试~~",
							});
						}
					});
			},
			//pagesize改变
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getTable();
			},

			//页码改变
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getTable();
			},

			//添加计划
			addPlan(type, result) {
				this.$router.push({
					path: '/salesPlan',
					query: {
						queryType: type,
						queryData: JSON.stringify(this.tableData[result])
					}
				})
			},
			addProductItem(index) {
				this.currentOptionIndex = index;
				this.table = true;
			},
			//关联商品切换页面++++++++++++++++++++++++
			// 查询商品
			searchProduct(ischange) {
				if (ischange) {
					this.pageNum2 = 1;
				}
				let url = "/api/product/product/product";
				return this.$http
					.get(url, {
						params: {
							pageNum: this.pageNum2,
							pageSize: this.pageSize2,
							keyword: this.keyword,
							// status:''
							sort: -1,
						},
					})
					.then((res) => {
						this.tableDataProduct = res.data.data.list;
						this.tableDataProduct.forEach((item, index) => {
							item.preview = [];
							item.preview = item.pics.split(",");
						});
						this.total2 = res.data.data.total;
					});
			},
			handleSizeChange2(val) {
				this.pageSize2 = val;
				this.searchProduct(false);
			},
			handleCurrentChange2(val) {
				this.pageNum2 = val;
				this.searchProduct(false);
			},
			delPlan(id) {
				this.$confirm('此操作将删除该条计划, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.post('/api/source/clrWeekPlan/update', {
						deleteStatus: 1,
						planId: id
					}).then(res => {
						if (res.data) {
							this.$message({
								type: 'success',
								message: '操作成功'
							});
							this.getTable()
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					});
				});
			}
		},
	};
</script>

<style lang="less" scoped>
	.scroll-view {
		max-height: 260px;
		overflow-y: scroll;
		overflow-x: hidden;
		margin: 10px;
	}

	.scroll-view::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 4px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	.scroll-view::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 2px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #66b8ff;
	}

	.scroll-view::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 2px;
		background: #ededed;
	}

	/deep/ .el-input {
		width: auto;
	}
</style>
